<template>
  <form class="form-signin card" v-on:submit.prevent="logar">
    <div class="card-body">
      <img src="/static/logo.webp" class="img-fluid" alt="Logo Caqui">
      <br><br><br>
      <!-- <h3 class="form-signin-heading text-center">Entrar</h3> -->
      <!-- <p class="text-center">
        Entrar
      </p> -->
      <input autocomplete="username" v-model="form.login" type="text" class="form-control mb-1" placeholder="Login" required autofocus>

      <div class="input-group mb-3">

        <input style="margin-bottom:10px" v-if="showPass" autocomplete="current-password" v-model="form.password" type="text" class="form-control" placeholder="Senha" required>
        <input v-if="!showPass" autocomplete="current-password" v-model="form.password" type="password" class="form-control" placeholder="Senha" required>

        <div @click="showPass = !showPass" v-if="showPass" class="input-group-append mt-2 ml-1">
          <i class="material-icons">
            visibility
          </i>
        </div>
        <div @click="showPass = !showPass" v-if="!showPass" class="input-group-append mt-2 ml-1">
          <i class="material-icons">
            visibility_off
          </i>
        </div>
      </div>


      <button class="btn btn-lg btn-success btn-raised btn-block" type="submit">Entrar</button>

      <p class="text-center">
      <small >
        Ao efetuar login você concorda com os <a data-toggle="modal" data-target="#termosModal" href="">termos de uso da plataforma.</a>
      </small>
      </p>

      <div class="alert alert-danger" role="alert" v-if="infoError">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
          <span class="sr-only">Close</span>
        </button>
        <strong>Erro!</strong> Usuário ou senha incorretos
      </div>
    </div>


      <div class="modal fade" id="termosModal" tabindex="-1" role="dialog" aria-labelledby="termosModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Termos de uso da plataforma Caqui <br>
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <pdf ref="pdf" :src="src" :page="page" @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>

                <div class="row">
                  <div class="col text-center">
                    <button @click="page -= 1" :disabled="page - 1 <= 0" type="button" class="btn btn-sm btn-raised btn-success">
                      <i class="material-icons">
                        navigate_before
                      </i>
                    </button>
                    <button @click="page += 1" :disabled="page + 1 > numPages" type="button" class="btn btn-sm btn-raised btn-success">
                      <i class="material-icons">
                        navigate_next
                      </i>
                    </button>
                  </div>
                </div>

            </div>
            <div class="modal-footer">
              <a target="_blank" href="/static/termos.pdf" class="btn btn-warning mr-2 btn-raised">Download</a>
              <button type="button" class="btn btn-secondary btn-raised" data-dismiss="modal">Ok</button>
            </div>
          </div>
        </div>
      </div>

  </form>
</template>

<script>
import store from '@/store';
import ls from 'local-storage';
import axios from 'axios';
import pdf from 'vue-pdf';

export default {
  components:{
    pdf
  },
  name: 'login',

  data() {
    return {
      infoError: false,
      form: {
        login: '',
        password: '',
      },
			src:'../static/termos.pdf',
			page: 1,
			numPages: 0,
      showPass: false,
    };
  },

  beforeCreate() {
    if (store.state.isLogged) {
      this.$router.push('/');
    }
  },
  beforeMount() {
    if (this.$route.params.token && this.$route.params.token !== 'null') {
      this.form.auto = true;
      this.form.token = this.$route.params.token;
      this.logar();
    }
  },
  methods: {
    password: function(updatePassword, reason) {
			updatePassword(prompt('password is "test"'));
		},
		error: function(err) {
			console.log(err);
		},
    logar() {
      this.infoError = false;

      axios
        .post(`${process.env.API_ENV}/api/login`, this.form)
        .then(response => {
          if (response.data.success) {
            ls('token', response.data.token);

            store.commit('LOGIN_USER');
            this.$router.push('/');
          } else {
            this.infoError = true;
          }
        });
    }
  }
};
</script>

<style>
.form-signin {
  max-width: 350px;
  padding: 15px;
  margin: 80px auto;
}
.form-signin .form-signin-heading,
.form-signin .checkbox {
  margin-bottom: 10px;
}
.form-signin .checkbox {
  font-weight: normal;
}
.form-signin .form-control {
  position: relative;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type='email'] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type='password'] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/app/auth/Login.vue